export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10763.46cdd795.jpg";